function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#006899",
  d: "M14.501 23.383v-6.154c0-0.677 0.554-1.231 1.231-1.231h4.923c0.677 0 1.231 0.554 1.231 1.231v4.923c0 0.677-0.554 1.231-1.231 1.231h-6.154zM12.655 23.999c0 0.677 0.554 1.231 1.231 1.231h8.615c0.677 0 1.231-0.554 1.231-1.231v-8.615c0-0.677-0.554-1.231-1.231-1.231h-8.615c-0.677 0-1.231 0.554-1.231 1.231v8.615z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d11250",
  d: "M5.886 18.281l2.001 4.002c0.303 0.605-0.003 1.101-0.68 1.101h-0.090c-0.677 0-1.785 0-2.462 0h-0.090c-0.677 0-0.983-0.495-0.68-1.101l2.001-4.002zM6.436 15.253c-0.303-0.605-0.798-0.605-1.101 0l-4.438 8.875c-0.303 0.605 0.003 1.101 0.68 1.101h3.077c0.677 0 1.785 0 2.462 0h3.077c0.677 0 0.983-0.495 0.68-1.101l-4.438-8.875z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#db5800",
  d: "M5.886 5.973l2.001 4.002c0.303 0.605-0.003 1.101-0.68 1.101h-0.090c-0.677 0-1.785 0-2.462 0h-0.090c-0.677 0-0.983-0.495-0.68-1.101l2.001-4.002zM6.436 2.946c-0.303-0.605-0.798-0.605-1.101 0l-4.438 8.875c-0.303 0.605 0.003 1.101 0.68 1.101h3.077c0.677 0 1.785 0 2.462 0h3.077c0.677 0 0.983-0.495 0.68-1.101l-4.438-8.875z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#008f68",
  d: "M18.193 1.845c-3.059 0-5.538 2.479-5.538 5.538s2.48 5.538 5.538 5.538 5.538-2.48 5.538-5.538c0-3.059-2.48-5.538-5.538-5.538zM18.193 11.076c-2.036 0-3.692-1.656-3.692-3.692s1.656-3.692 3.692-3.692c1.462 0 2.729 0.855 3.326 2.091l-3.203 1.602 3.203 1.602c-0.598 1.236-1.864 2.091-3.326 2.091z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#032838",
  d: "M34.125 3.865h3.486l5.672 21.091h-2.718l-1.506-5.79h-6.735l-1.566 5.79h-2.718l6.085-21.091zM32.854 17.040h5.672l-2.688-10.191h-0.059l-2.924 10.191z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#032838",
  d: "M52.202 13.938c0-1.536-0.62-3.279-2.511-3.279-1.536 0-3.102 0.768-3.102 6.558 0 2.068 0.030 6.203 3.013 6.203 2.127 0 2.599-2.245 2.599-3.958h2.481c0 2.511-1.241 5.908-5.199 5.908-3.87 0-5.494-2.688-5.494-8.123 0-3.958 0.768-8.537 5.642-8.537 4.313 0 5.051 3.397 5.051 5.228h-2.481z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#032838",
  d: "M56.869 13.909c0-3.604 1.536-5.199 5.317-5.199 4.815 0 4.815 2.895 4.815 4.549v8.832c0 0.65 0 1.27 0.768 1.27 0.325 0 0.473-0.059 0.591-0.148v1.772c-0.177 0.029-0.827 0.148-1.447 0.148-0.945 0-2.127 0-2.245-2.038h-0.059c-0.798 1.418-2.334 2.274-3.811 2.274-2.954 0-4.313-1.772-4.313-4.608 0-2.215 0.945-3.751 2.984-4.372l3.338-1.004c1.802-0.561 1.802-1.063 1.802-2.393 0-1.477-0.886-2.334-2.54-2.334-2.718 0-2.718 2.54-2.718 3.102v0.148h-2.481zM64.519 16.331c-0.916 0.975-3.101 1.182-4.224 1.861-0.798 0.502-1.211 1.123-1.211 2.511 0 1.595 0.561 2.718 2.245 2.718 1.625 0 3.19-1.388 3.19-3.013v-4.076z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#032838",
  d: "M80.795 24.956h-2.363v-1.95h-0.059c-0.325 1.182-1.713 2.363-3.427 2.363-3.751 0-5.169-3.338-5.169-8.33 0-3.308 0.532-8.33 4.992-8.33 1.418 0 2.924 0.857 3.486 2.215h0.059v-7.060h2.481v21.091zM75.271 23.243c2.747 0 3.19-2.599 3.19-6.203 0-3.072-0.532-6.203-3.19-6.203-2.304 0-2.895 2.422-2.895 6.203s0.591 6.203 2.895 6.203z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#db5800",
  d: "M84.192 3.865h2.481v21.091h-2.481v-21.091z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#db5800",
  d: "M88.74 9.123h2.718l3.131 12.702h0.059l2.777-12.702h2.718l-4.578 16.896c-0.591 2.186-1.241 4.136-4.224 4.136-0.975 0-1.388-0.059-1.802-0.089v-1.95c0.355 0.059 0.827 0.089 1.448 0.089 1.152 0 1.654-0.68 1.95-1.536l0.473-1.388-4.667-16.158z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#bababa",
  d: "M25.961 1.845h0.123v23.385h-0.123v-23.385z"
});

function SvgAcadlyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcadlyLogo);
export default __webpack_public_path__ + "static/media/acadly-logo.f4bd0fd1.svg";
export { ForwardRef as ReactComponent };